import type { GetTweets200PageAllOf } from './getTweets200PageAllOf';
import type { GetTweets200PageAllOfThree } from './getTweets200PageAllOfThree';

export type GetTweets200Page = GetTweets200PageAllOf & GetTweets200PageAllOfThree;
